import { Controller, UseFormReturn } from "react-hook-form";
import { CompensationProfileFormInput } from "../types";
import TextField from "@/components/TextField";
import { NumberFormatBase } from "react-number-format";
import Divider from "@/components/Divider";
import { currencyFormatterNoDecimals } from "@/lib/currencyHelpers";

export default function LessonIncomeDetailsStep({ form }: { form: UseFormReturn<CompensationProfileFormInput> }) {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4">
        <div className="text-headline-small">Enter lesson income details.</div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 pt-4">
          <div className="col-span-full md:col-span-2">
            <Controller
              control={form.control}
              name="pgaJrlIncome"
              render={({ field }) => (
                <NumberFormatBase
                  disabled={false}
                  value={field.value}
                  name="pgaJrlIncome"
                  className="w-full"
                  customInput={TextField}
                  error={!!form.formState.errors.pgaJrlIncome}
                  errorText={form.formState.errors.pgaJrlIncome?.message as string}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  format={currencyFormatterNoDecimals}
                  onValueChange={(values) => {
                    field.onChange(values.value ? parseInt(values.value, 10) : null);
                    form.trigger("pgaJrlIncome");
                  }}
                  leadingIcon="attach_money"
                  label="PGA Jr. League Income"
                  placeholder="PGA Jr. League Income"
                />
              )}
            />
          </div>
          <div className="col-span-full md:col-span-2">
            <Controller
              control={form.control}
              name="privateLessonIncome"
              render={({ field }) => (
                <NumberFormatBase
                  disabled={false}
                  value={field.value}
                  name="privateLessonIncome"
                  className="w-full"
                  customInput={TextField}
                  error={!!form.formState.errors.privateLessonIncome}
                  errorText={form.formState.errors.privateLessonIncome?.message as string}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  format={currencyFormatterNoDecimals}
                  onValueChange={(values) => {
                    field.onChange(values.value ? parseInt(values.value, 10) : null);
                    form.trigger("privateLessonIncome");
                  }}
                  leadingIcon="attach_money"
                  label="Private Lesson Income"
                  placeholder="Private Lesson Income"
                />
              )}
            />
          </div>
          <div className="col-span-full md:col-span-2">
            <Controller
              control={form.control}
              name="groupLessonIncome"
              render={({ field }) => (
                <NumberFormatBase
                  disabled={false}
                  value={field.value}
                  name="groupLessonIncome"
                  className="w-full"
                  customInput={TextField}
                  error={!!form.formState.errors.groupLessonIncome}
                  errorText={form.formState.errors.groupLessonIncome?.message as string}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  format={currencyFormatterNoDecimals}
                  onValueChange={(values) => {
                    field.onChange(values.value ? parseInt(values.value, 10) : null);
                    form.trigger("groupLessonIncome");
                  }}
                  leadingIcon="attach_money"
                  label="Group Lesson Income"
                  placeholder="Group Lesson Income"
                />
              )}
            />
          </div>
          <div className="col-span-full md:col-span-2">
            <Controller
              control={form.control}
              name="otherLessonIncome"
              render={({ field }) => (
                <NumberFormatBase
                  disabled={false}
                  value={field.value}
                  name="otherLessonIncome"
                  className="w-full"
                  customInput={TextField}
                  error={!!form.formState.errors.otherLessonIncome}
                  errorText={form.formState.errors.otherLessonIncome?.message as string}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  format={currencyFormatterNoDecimals}
                  onValueChange={(values) => {
                    field.onChange(values.value ? parseInt(values.value, 10) : null);
                    form.trigger("otherLessonIncome");
                  }}
                  leadingIcon="attach_money"
                  label="Other Lesson Income"
                  placeholder="Other Lesson Income"
                />
              )}
            />
          </div>
        </div>
        <div className="col-span-full">
          <Controller
            control={form.control}
            name="lessonPercentageSplit"
            render={({ field }) => (
              <NumberFormatBase
                value={field.value}
                disabled={false}
                name="lessonPercentageSplit"
                className="w-full"
                customInput={TextField}
                error={!!form.formState.errors.lessonPercentageSplit}
                errorText={form.formState.errors.lessonPercentageSplit?.message as string}
                onFocus={(e) => {
                  e.target.select();
                }}
                onValueChange={(values) => {
                  field.onChange(values.floatValue ?? null);
                  form.trigger("lessonPercentageSplit");
                }}
                leadingIcon="percent"
                label="What percentage of your lesson income does your facility retain?"
                placeholder="What percentage of your lesson income does your facility retain?"
              />
            )}
          />
        </div>
        <div className="py-3">
          <Divider />
        </div>
        <div className="flex justify-between gap-4">
          <p className="text-title-medium">Total Lesson Income</p>
          <p className="text-title-medium">
            ${" "}
            {currencyFormatterNoDecimals(
              (
                Number(form.getValues("pgaJrlIncome") || 0) +
                Number(form.getValues("privateLessonIncome") || 0) +
                Number(form.getValues("groupLessonIncome") || 0) +
                Number(form.getValues("otherLessonIncome") || 0)
              ).toString()
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
